<lib-page-container [title]="title" subtitle="{{ total >=0 ? ((total|number:'2.') + ' receipt codes') : '' }}"
  [loading]="loading" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button (click)="grid.openFilters()" tooltip="Search receipt code" icon="search">Search</lib-button>
    <lib-button *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_CREATE]"
      icon="more_vert" [matMenuTriggerFor]="appMenu" tooltip="More actions"></lib-button>
    <mat-menu #appMenu="matMenu" class="mat-menu">
      <button mat-menu-item (click)="generateSample()">
        <mat-icon>auto_fix_high</mat-icon>
        Generate sample
      </button>
    </mat-menu>
  </div>
  <div lib-page-body>
    <app-receipt-code-grid #grid></app-receipt-code-grid>
  </div>
</lib-page-container>